import { z } from "zod"

// Base iframe message schema
export const BaseIframeMessageSchema = z.object({
  type: z.string(),
  source: z.enum(["parent", "child"]),
  timestamp: z.number(),
})

// Auth token payload
export const AuthTokenPayloadSchema = z.object({
  token: z.string(),
  expiresAt: z.number(),
})

// Auth token message
export const AuthTokenMessageSchema = BaseIframeMessageSchema.extend({
  type: z.literal("AUTH_TOKEN"),
  payload: AuthTokenPayloadSchema,
})

// Auth token request message
export const AuthTokenRequestMessageSchema = BaseIframeMessageSchema.extend({
  type: z.literal("AUTH_TOKEN_REQUEST"),
})

// Resize message
export const ResizeMessageSchema = BaseIframeMessageSchema.extend({
  type: z.literal("RESIZE"),
  payload: z.object({
    height: z.number().optional(),
    width: z.number().optional(),
  }),
})

export const SetVisitorMessageSchema = BaseIframeMessageSchema.extend({
  type: z.literal("SET_VISITOR"),
  payload: z.unknown(),
})

export const ClearVisitorMessageSchema = BaseIframeMessageSchema.extend({
  type: z.literal("CLEAR_VISITOR"),
})

// Error message
export const IframeErrorMessageSchema = BaseIframeMessageSchema.extend({
  type: z.literal("ERROR"),
  payload: z.object({
    code: z.string(),
    message: z.string(),
  }),
})

// Ready message (sent when iframe is loaded)
export const ReadyMessageSchema = BaseIframeMessageSchema.extend({
  type: z.literal("READY"),
})

// Combined message schema
export const IframeMessageSchema = z.discriminatedUnion("type", [
  AuthTokenMessageSchema,
  AuthTokenRequestMessageSchema,
  ResizeMessageSchema,
  IframeErrorMessageSchema,
  ReadyMessageSchema,
  SetVisitorMessageSchema,
  ClearVisitorMessageSchema,
])

// Inferred types
export type AuthTokenPayload = z.infer<typeof AuthTokenPayloadSchema>;
export type AuthTokenMessage = z.infer<typeof AuthTokenMessageSchema>;
export type AuthTokenRequestMessage = z.infer<
  typeof AuthTokenRequestMessageSchema
>;
export type ResizeMessage = z.infer<typeof ResizeMessageSchema>;
export type IframeErrorMessage = z.infer<typeof IframeErrorMessageSchema>;
export type ReadyMessage = z.infer<typeof ReadyMessageSchema>;
export type SetVisitorMessage = z.infer<typeof SetVisitorMessageSchema>;
export type ClearVisitorMessage = z.infer<typeof ClearVisitorMessageSchema>;
export type IframeMessage = z.infer<typeof IframeMessageSchema>;

// Listener callback type
export type IframeMessageListener = (message: IframeMessage) => void;
